import * as zod from 'zod';

import { HardwareConfigEquipmentMapping } from '@sb/ai/types';

import { Expression } from '../../types';

// An expression tag with a display name for the UI
export const TagExpression = zod.object({
  kind: zod.literal('TagExpression'),
  expression: Expression,
  displayName: zod.string(), // The user-friendly name shown in the UI
});

export type TagExpression = zod.infer<typeof TagExpression>;

// A tag can be either a simple string or an expression with a display name
const TagValue = zod.union([zod.string().max(30), TagExpression]);

export type TagValue = zod.infer<typeof TagValue>;

export default zod.object({
  taskId: zod.string().nullable().default(null),
  hardwareConfigEquipmentMapping: HardwareConfigEquipmentMapping.default({}),
  userId: zod.string().nullable().default(null),
  projectId: zod.string().nullable().default(null),
  timeout: zod.number().int().positive().default(300),
  tags: zod.array(TagValue).default([]),
  uploadRecording: zod.boolean().default(true),
  waitForUpload: zod.boolean().default(true),
});
